module.exports = __webpack_public_path__ + "static/media/info.340d425c.svg";